// Copyright (c) Ensho Health, 2021 to present

import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import actions from '../../state-manager/action';
import { ROUTES } from '../../constants.js';
import FormForgotPassword from '../../component/forgot-password/FormForgotPassword.js';

import { StyledPage, StyledMessage } from './ForgotPassword.styles.js';

const ForgotPassword = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  async function onSubmit(info) {
    try {
      dispatch(actions.auth.forgotPassword(info));
    } catch (error) {
      console.error(error.message);
    }
  }

  const onBack = () => {
    history.push(ROUTES.LOGIN);
  };

  useEffect(() => {
    if (auth.transaction) {
      dispatch(actions.auth.handleNewTransaction());
    }
  }, [dispatch, auth.transaction]);

  const displayForm =
    !auth.transaction ||
    !['RECOVERY_CHALLENGE'].includes(auth.transaction?.status);
  const displayCheckEmail = ['RECOVERY_CHALLENGE'].includes(
    auth.transaction?.status
  );
  return (
    <StyledPage>
      {displayForm && (
        <FormForgotPassword
          onSubmit={onSubmit}
          onBack={onBack}
          loading={auth.loading}
          errorMessage={auth.error}
        />
      )}

      {displayCheckEmail && (
        <StyledMessage>
          <div style={{ fontSize: 18, fontWeight: 500, textAlign: 'center' }}>
            Check Your Email
          </div>
          <p style={{ marginTop: 30 }}>
            A link to reset your password was just sent to the email address you
            provided if it is authorized to access the Platform. Please contact
            your account manager if you do not receive one.
          </p>
        </StyledMessage>
      )}
    </StyledPage>
  );
};

export default ForgotPassword;
